module.exports = __webpack_public_path__ + "img/ch09_08_腿变云.93c57377.jpg";